import { render } from "./CoursesListPage.vue?vue&type=template&id=5c4c37c6&ts=true"
import script from "./CoursesListPage.vue?vue&type=script&lang=ts"
export * from "./CoursesListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__